import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import {sync} from 'vuex-router-sync'
import {merge, isFunction} from 'lodash'
import App from './App'

//Store--------------------------------
let modules = {};
let plugins = [];

const moduleBundles = require.context("./views", true, /vuex-module\.js/);
moduleBundles.keys().forEach(key => {
    merge(modules, moduleBundles(key).default)
});

const pluginBundles = require.context("./views", true, /vuex-plugin\.js/);
pluginBundles.keys().forEach(key => {
    plugins = plugins.concat(pluginBundles(key).default)
});

const externalServices = require('./services').services;
//console.log(externalServices);
externalServices.forEach(s => {
    if (s.vuexModule) merge(modules, s.vuexModule);
    if (s.vuexPlugin) plugins = plugins.concat(s.vuexPlugin);
});


Vue.use(Vuex);

//console.log(plugins);
//console.log(modules);

import createPersistedState from "vuex-persistedstate";


const store = new Vuex.Store({
    modules,
    //plugins: plugins.filter(isFunction)
    plugins: plugins.filter(isFunction).concat(createPersistedState())
});
//-------------------------------------

//Router-------------------------------
let routes = [];

const routeBundles = require.context("./views", true, /routes\.js/);
routeBundles.keys().forEach(key => routes = routes.concat(routeBundles(key).default));

//console.log(routes)

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    linkActiveClass: 'active',
    mode: 'history', // do not use /#/.
});

//-------------------------------------

//Components auto regestration

const componentBundles = require.context("./components", true, / *\.vue/);
componentBundles.keys().forEach(componentPath => {
    const comp = componentBundles(componentPath).default;
    if (comp.name) Vue.component(comp.name, comp); else console.warn(componentPath+" not have property name")
});


//-----------------------------


//Plugins-------------------------------
require('./plugins');
//--------------------------------------

//jQuery and another js library
//window.$ = window.jQuery = require('jquery');
//require("semantic-ui-css");

// Effortlessly keep vue-router and vuex store in sync.
sync(store, router); // https://github.com/vuejs/vuex-router-sync/tree/next

//Hooks
const hooks = {
    beforeCreateVueInstance: []
};

const hookBundles = require.context("./views", true, /hooks\.js/);
hookBundles.keys().forEach(key => {
    hooks.beforeCreateVueInstance = [...hooks.beforeCreateVueInstance, ...hookBundles(key).beforeCreateVueInstance]
});

externalServices.forEach(s => {
    if (s.hooks) hooks.beforeCreateVueInstance = [...hooks.beforeCreateVueInstance, ...s.hooks.beforeCreateVueInstance]

});

hooks.beforeCreateVueInstance.forEach(h => h(store, router));

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
